/*global gsap, ScrollTrigger */

export default {
  init() {

    // JavaScript to be fired on all pages
    $('.iris-table').wrap('<div class="table-responsive"></div>');

    /** Register ScrollTrigger Plugin */
    gsap.registerPlugin(ScrollTrigger);

    function getRandomInt(max) {
      return Math.floor(Math.random() * max);
    }

    const blockImages = document.querySelectorAll('.wp-block-image figure, .image-tile');
    if (blockImages.length) {
      blockImages.forEach(element => {
        element.id = 'img-' + getRandomInt(999);
        $(element).append('<span class="img-bg"></span>');
      });
    }

    // Animate Text Image Block
    gsap.utils.toArray('.wp-block-image, .image-tile').forEach(section => {

      const imgBG = section.querySelector('.img-bg');
      const imgPop = section.querySelector('img');

      var imageAnim = gsap.timeline();

      imageAnim.from(imgBG, {
        scaleX: 0,
        transformOrigin: 'left',
      }).to(imgPop, {
        duration: 0.1,
        opacity: 1,
      }).to(imgBG, {
        scaleX: 0,
        transformOrigin: 'right',
      });

      ScrollTrigger.create({
        trigger: imgBG,
        animation: imageAnim,
        start: '20px 80%',
        end: 'bottom 100px',
        ease: 'expo.outout',
        toggleActions: 'restart none none reverse',
      });

    });

    gsap.utils.toArray('.main p, .main h3, .main h2, .main h4, .main h5, .main h6, .main ul').forEach(section => {
      let p = gsap.timeline({
        scrollTrigger: {
          trigger: section,
          start: '-=500top center',
          end: () => '+=' + section.offsetHeight,
          toggleActions: 'restart none none reverse',
        },
      });
      p.from(section, 1, { opacity: 0 }, 'reveal');
    });

    const underLine = document.querySelectorAll('.underline');
    if (underLine.length) {
      underLine.forEach(element => {
        $(element).append('<span class="underline-anim pt-2" style="0%"></span>');
      });
    }

    const expandingCard = document.querySelectorAll('.expanding-card');
    if (expandingCard.length) {
      expandingCard.forEach(element => {
        $(element).find('.collapse').first().before('<span class="underline-anim" style="0%"></span>');
      });
    }
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    $('.testimonial-slider').slick({
      dots: false,
      infinite: true,
      speed: 300,
      autoplay: true,
      slidesToShow: 1,
      autoplaySpeed: 4000,
      prevArrow: '<span class="slick-prev"></span>',
      nextArrow: '<span class="slick-next"></span>',
    });

    $('.logo-slider').slick({
      dots: false,
      infinite: true,
      speed: 300,
      autoplay: true,
      slidesToShow: 6,
      autoplaySpeed: 4000,
      prevArrow: '<span class="slick-prev"></span>',
      nextArrow: '<span class="slick-next"></span>',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            infinite: true,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });

    gsap.utils.toArray('.underline-anim').forEach(section => {
      var underlineAnim = gsap.timeline();
      underlineAnim.from(section, {
        scaleX: 0,
        transformOrigin: 'left',
      })
      ScrollTrigger.create({
        trigger: section,
        animation: underlineAnim,
        start: '-=350top center',
        end: () => '+=' + section.offsetHeight,
        ease: 'expo.outout',
        toggleActions: 'restart none none reverse',
      });
    });

    /* Gallery Images */
    $('.wp-block-image a.single-img-popup').magnificPopup({
      type: 'image',
      closeOnContentClick: true,
      closeBtnInside: false,
      fixedContentPos: true,
      mainClass: 'mfp-no-margins mfp-with-zoom',
      image: {
        verticalFit: true,
      },
      zoom: {
        enabled: true,
        duration: 300,
      },
    });

    $('a.content').magnificPopup({
      disableOn: 700,
      type: 'iframe',
      mainClass: 'mfp-fade mfp-iframe-lg',
      removalDelay: 160,
      preloader: false,
      fixedContentPos: false,
    });

    $('.wp-block-button.iframe a').magnificPopup({
      disableOn: 700,
      type: 'iframe',
      mainClass: 'mfp-fade mfp-iframe-lg',
      removalDelay: 160,
      preloader: false,
      fixedContentPos: false,
    });

    $('.wp-block-gallery').each(function () {
      $(this).magnificPopup({
        delegate: 'a',
        type: 'image',
        closeOnContentClick: true,
        closeBtnInside: false,
        fixedContentPos: true,
        mainClass: 'mfp-no-margins mfp-with-zoom',
        image: {
          verticalFit: true,
        },
        zoom: {
          enabled: true,
          duration: 300,
        },
        gallery: {
          enabled: true,
          navigateByImgClick: true,
        },
      })
    });

    /** 
     * Auto open accordions
     */
    
    var hasLink = window.location.hash;
    var accordionID = hasLink.replace('#', '');

    if(accordionID) {
      var accordionContent = document.getElementById(accordionID+'-link');
      $(accordionContent).collapse('toggle');
    }

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js